import { Fab } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import AddIcon from "@material-ui/icons/Add";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import DeleteDialog from "../../DeleteDialog";
import FormDialogHolder from "../../FormDialogHolder";
import TableHolder from "../../TableHolder";
import { Holder } from "../../../interfaces";
import { holderActions, holderSelectors } from "../../../redux";

const useStyles = makeStyles((theme) => ({
  actionButtons: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
}));

const HolderPage = () => {
  const [selectedHolder, setSelectedHolder] = useState<Holder | undefined>();
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState<boolean>(false);
  const [deleteId, setDeleteId] = useState("");
  const [holderDialogOpen, setHolderDialogOpen] = useState(false);
  const classes = useStyles();
  const dispatch = useDispatch();

  const handleDeleteDialogOpen = (id: string) => {
    setDeleteId(id);
    setIsDeleteDialogOpen(true);
  };

  const handleCloseDeleteDialogOpen = () => {
    dispatch(holderActions.clear("deletedHolder"));
    setIsDeleteDialogOpen(false);
    dispatch(holderActions.loadAllHolders({}));
  };

  const handleCreateNewHolder = () => {
    setSelectedHolder(undefined);
    setHolderDialogOpen(true);
  };

  const handleEditHolder = (holder: Holder | undefined) => {
    setSelectedHolder(holder);
    setHolderDialogOpen(true);
  };

  return (
    <div>
      <div className={classes.actionButtons}>
        <Fab onClick={handleCreateNewHolder} variant="extended" color="primary">
          <AddIcon></AddIcon>Crea nuovo Gestore
        </Fab>
      </div>
      <TableHolder
        onDeleteHolder={handleDeleteDialogOpen}
        onEditHolder={handleEditHolder}
      ></TableHolder>
      <DeleteDialog
        isOpen={isDeleteDialogOpen}
        onClose={handleCloseDeleteDialogOpen}
        deleteAction={holderActions.deleteHolderById}
        selector={holderSelectors.getDeletedHolder}
        id={deleteId}
      />
      {selectedHolder ? (
        <FormDialogHolder
          holderToUpdate={selectedHolder}
          isOpen={holderDialogOpen}
          onClose={() => setHolderDialogOpen(false)}
        />
      ) : (
        <FormDialogHolder
          isOpen={holderDialogOpen}
          onClose={() => setHolderDialogOpen(false)}
        />
      )}
    </div>
  );
};

export default React.memo(HolderPage);
